import XBtn from './XBtn.vue'
export default XBtn
